import { atom } from "recoil"

export const organizationMemberImageRefresherState = atom<boolean>({
  key: "atoms/organization/organizationMemberImageRefresherState",
  default: false,
})
